fragment ContentListFragment on contentList_Entry {
  typeHandle
  heading
  tiles: educationContentListTiles {
    ... on educationTilesBlock_Entry {
      id
      description
      image {
        url
        title
      }
      cta {
        ...LinkFragment
      }
      academyPage {
        ... on education_Entry {
          title
          price
          compareAtPrice
        }
      }
    }
  }
}
